import { plus, noop } from '@lsfe/tools';

// table 合计
export const getSummaries = (params = {}, propList = [], formatter = noop) => {
    const { columns, data } = params;
    return columns.slice(1).reduce(
        (prev, cur) => {
            const { property } = cur;
            let total = '';
            if (propList.includes(property)) {
                total = plus(data.map(v => +v[property]) || 0);
                if (formatter !== noop) {
                    total = formatter(total, params);
                }
            }
            prev.push(total);
            return prev;
        },
        ['合计']
    );
};
